import React from 'react'

import { Tooltip } from '@junglescout/edna'

import { KEYWORD_ENGINE_TOOLTIPS } from 'constants/keyword_engine/tooltips'
import { KEYWORD_ENGINE_SEARCH_TYPES } from 'constants/keyword_engine_search_types'

import { parseCurrency } from 'helpers/currency'
import { isAsin, everyIsAsin } from 'helpers/amazon'
import { isFeatureEnabled } from 'helpers/features'
import { sendCtaClickEvent } from 'helpers/segment'
import { getPathData } from 'services/segment'

export const renderNaTooltip = column => {
  const tooltipContent = KEYWORD_ENGINE_TOOLTIPS.noData[column]

  if (tooltipContent) {
    return (
      <Tooltip content={tooltipContent} side="bottom" size="medium">
        <span>-</span>
      </Tooltip>
    )
  }
  return null
}

export const giveawayFormatter = val => {
  if (val) return parseInt(val, 10).toLocaleString()

  return renderNaTooltip('avgGiveaway')
}

export const bidFormatter = (val, item, column) => {
  if (val) return parseCurrency(val, item.currencyCode)

  return renderNaTooltip(column)
}

export const baseKeywordScoutFormatter = (val, column) => {
  if (val === 0) return val
  return val || renderNaTooltip(column)
}

export const bidFormatterV2 = (val, item, column) => {
  if (val) return parseCurrency(val, item.currencyCode)

  return renderNaTooltip(column)
}

export const getSearchType = searchTerm => {
  const { keyword, singleAsin, multipleAsins } = KEYWORD_ENGINE_SEARCH_TYPES

  // input is treated as keyword (text search, not ASIN(s))
  if (!Array.isArray(searchTerm)) return keyword
  if (searchTerm.length === 0) return keyword
  if (searchTerm.length === 1 && !isAsin(searchTerm[0])) return keyword

  // input is treated as single ASIN
  if (searchTerm.length === 1 && isAsin(searchTerm[0])) return singleAsin
  if (
    searchTerm.length > 1 &&
    isAsin(searchTerm[0]) &&
    !everyIsAsin(searchTerm)
  )
    return singleAsin

  // input is treated as multiple ASINs
  if (searchTerm.length > 1 && everyIsAsin(searchTerm)) return multipleAsins

  return keyword
}

export const filterColumnsBySearchType = props => {
  const { columns, flagData, currentSearchType } = props

  const enabledColumns = columns.filter(column => {
    // check conditions one by one
    if (
      column?.featureFlag &&
      !isFeatureEnabled(column.featureFlag, flagData)
    ) {
      return false
    }

    if (column?.displayFor && !column.displayFor.includes(currentSearchType)) {
      return false
    }

    return true
  })

  return enabledColumns
}

export const getTableKey = (id, searchType) => {
  switch (searchType) {
    case KEYWORD_ENGINE_SEARCH_TYPES.singleAsin:
      return `${id}-single`
    case KEYWORD_ENGINE_SEARCH_TYPES.multipleAsins:
      return `${id}-multiple`
    default:
      return `${id}-keyword`
  }
}

export function trackSegmentRowClickEvent(e) {
  const targetClassname = e?.target?.className
  const elClassName =
    typeof targetClassname === 'string' && targetClassname.split('-')?.[0]

  // Avoid sending duplicate row click events if that is a 'View Insights' button.
  // We have a separate event for that
  if (
    !['ContentWrapper', 'ButtonContent', 'ButtonWrapper'].includes(elClassName)
  ) {
    sendCtaClickEvent({
      destination: 'modal',
      text: 'Table Row',
      location: getPathData(window.location?.hash?.substr(1))?.name
    })
  }
}
